import { render, staticRenderFns } from "./ShoppingDetails.vue?vue&type=template&id=a80d9f9e&"
import script from "./ShoppingDetails.vue?vue&type=script&lang=js&"
export * from "./ShoppingDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports